module.exports = __webpack_public_path__ + "static/media/logo-vtex.5d1494ff.svg";